<template>
  <nav id="leftSidebar" :class="classes">
    <div class="lhs-top-stack">
      <div v-if="brandComponents.length" class="ws-brand-zone">
        <DynamicComponents :components="brandComponents" />
      </div>
      <LhsHeaderCard />
    </div>

    <DynamicComponents :components="restComponents" />

    <AdminSubnav />
  </nav>
</template>

<script>
/**
 * TheLeftSidebar (icarus-theme-base) — three-row vertical layout:
 *
 *   1. Brand zone (first ImageTile from `components`, if any)
 *   2. LhsHeaderCard (account / user menu — see sibling component)
 *   3. Main nav (the rest of `components`)
 *   4. AdminSubnav (sticky secondary column when on /admin/*)
 *
 * Heuristic: the brand block is always the first ImageTile in `components`.
 * Anything else, including a stray later ImageTile, stays in restComponents.
 * Vendor naming varies (`ImageTile` vs `imageTile`) — case-insensitive match.
 *
 * Overrides icarus-core's default left sidebar. Registered via the L4 build-
 * time theme tier (ICARUS_THEME=base + themes/base/structure/ auto-loaded
 * by index.js's 3-tier registration).
 */
import DynamicComponents from "@apexl/icarus-core/src/components/partials/DynamicComponents.vue";
import commonProps from '@apexl/icarus-core/src/components/_properties/common';

export default {
  name: 'TheLeftSidebar',
  components: { DynamicComponents },
  props: {
    ...commonProps,
    components: { type: Array, default: () => ([]) },
  },
  computed: {
    brandComponents() {
      const first = (this.components || [])[0];
      if (first && this.isBrandComponent(first)) return [first];
      return [];
    },
    restComponents() {
      const all = this.components || [];
      const first = all[0];
      if (first && this.isBrandComponent(first)) return all.slice(1);
      return all;
    },
  },
  methods: {
    isBrandComponent(c) {
      const name = c?.name || c?.componentName || c?.type || '';
      return /image[-_ ]?tile/i.test(String(name));
    },
  },
};
</script>
